import { FC } from "react";
import { SCUIContent } from "../../../atomic/organisms";
import "./NotFound.scss";
import meymun from "../../../../src/images/meymun.png";
import { useTranslation } from "react-i18next";
export const NotFound: FC<any> = () => {
  const { t } = useTranslation();
  return (
    <SCUIContent>
      <div id="notfound">
        <div className="notfound">
          <div>
            <img src={meymun} width="600" alt=""></img>
          </div>
          <h2>{t("general.dontPage")}</h2>

          <p>{t("general.dontPageMessage")}</p>
        </div>
      </div>
    </SCUIContent>
  );
};
//https://img-lcwaikiki.mncdn.com/Resource/Images/Other/notFound1(3x).png
